import React, { useEffect } from "react";
import "./Background.scss"; // Ensure you have the correct path to your CSS file

const Background = () => {
    useEffect(() => {
        const loadVanta = async () => {
            // Dynamically load three.js
            const threeScript = document.createElement("script");
            threeScript.src = "https://cdnjs.cloudflare.com/ajax/libs/three.js/r134/three.min.js"; // Ensure this path is correct
            threeScript.async = true;
            document.body.appendChild(threeScript);

            // Wait for three.js to load
            threeScript.onload = () => {
                // Dynamically load vanta.waves.min.js
                const vantaScript = document.createElement("script");
                vantaScript.src = "https://cdn.jsdelivr.net/npm/vanta@latest/dist/vanta.waves.min.js"; // Ensure this path is correct
                vantaScript.async = true;
                document.body.appendChild(vantaScript);

                // Wait for vanta.waves.min.js to load
                vantaScript.onload = () => {
                    if (window.VANTA) {
                        window.VANTA.WAVES({
                            el: "#background1",
                            color: 0xac1754,
                            shininess: 50,
                            waveHeight: 20,
                            waveSpeed: 1.2,
                            mouseControls: true,
                            touchControls: true,
                            gyroControls: true,
                            scale: 1.00,
                            scaleMobile: 1.00
                        });
                    }
                };
            };
        };

        loadVanta();

        // Cleanup function to destroy Vanta effect
        return () => {
            if (window.VANTA && window.VANTA.current) {
                window.VANTA.current.destroy();
            }
        };
    }, []);

    return (
        <>
            <div id="background1"></div>
        </>
    );
};

export default Background;